import { createSelector } from 'reselect';

export const getCharts = (state) => state.charts;

export const getUserCharts = createSelector(getCharts, charts => charts.charts);

export const getChart = createSelector(getCharts, charts => charts.chart);

export const getChartType = createSelector(getCharts, charts => charts.chartType);